export const getImages = (tag, images, imagesFormData, incidentID) => {
    let tags = [
      {
        tag: tag,
        images: [],
      },
    ];
  
    images.forEach((image) => {
      tags[0].images.push(image.name);
    });
  
    let combinedFormData = new FormData();
    combinedFormData.append("tagsWithImages", JSON.stringify(tags));
  
    for (const [key, value] of imagesFormData.entries()) {
      combinedFormData.append("images", value, value.name);
    }

    return {
      tags,
      combinedFormData,
    };
  };